import { LEVEL } from '_utils/level';

export const _LOAD_PUZZLE_WALLS_MODEL_ = 'Load:PuzzleWallsPuzzle';

export const CELL = {
  id: null,
  positionx: 0,
  positiony: 0,
  shape: null,
  value: null,
  filled: true,
  color: null,
  direction: null,
  isBlocked: false,
};

export const SETTINGS = {
  showAnswer: true,
  colored: true,
  pathWeight: 'normal',
  density: 25,
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 8,
  rows: 10,
  columns: 10,
  level: LEVEL.MEDIUM,
  settings: { ...SETTINGS },
  table: [],
};

export const CELL_SIZE = 60;

export const MIN_DIMENSIONS = {
  ROWS: 5,
  COLUMNS: 5,
};

export const DENSITY_BASE = 25;
export const DENSITY_REFERENCE_SIZE = 10;
export const DENSITY_REFERENCE_OFFSET = 5;
export const DENSITY_ADJUSTMENT_STEP = 2;
